import { getInstance } from "@harbor/anchor/runtime";
import actionTypes from "./actionTypes";
import {
  isCustom,
  setLocalStorageFlag,
  updateCookie,
  getStoredCurrentSite,
  getStoredTimePeriod,
  validateTimePeriodSelected,
  validateTimePeriodSelectedSidebarPayload,
  getConvergedCookie,
} from "../../utils/common";
import { getDefaultTimeFilter } from "../../utils/query-utils";
import { setRumUser, updateRumSite } from "../../monitoring";
import {
  getTimePeriodELT,
  shortDisplayDate24HourWithSec,
  formatDate,
  getFormattedUTCDate,
} from "../../utils/displayTime";
import {
  timeFilterTypesCustomV4,
  timeFilterTypes,
  ANCHOR_COMMAND_IDS,
  ANCHOR_PROPERTY_IDS,
  customTimeFilterText,
} from "../../utils/enums";
import {
  getInitialToggleView,
  isApplicationMFERoute,
  storeToggleView,
  getToggleConfig,
} from "../../utils/toggleView";
import { getCookie } from "../../serviceWorker";

const currentOverlay = "currentOverlay";
const currentOverlayName = "currentOverlayName";
const roles = "roles";
const currentSite = getStoredCurrentSite();
const timeFilterInit = getStoredTimePeriod();
const timePeriodArray = getTimePeriodELT(timeFilterInit);
const isUIConverged = getCookie("cl-analytics");
const isNonSiteSelectionEnabledInit =
  getCookie("cl-nh-selection-enabled") === "true";
const getSanitizedAndDecodedCookie = (cookieName) => {
  const rawValue = getCookie(cookieName) || "";
  const sanitized =
    rawValue && rawValue !== "null" && rawValue !== "undefined" ? rawValue : "";
  if (!sanitized) return "";
  try {
    return decodeURIComponent(sanitized);
  } catch (error) {
    return sanitized;
  }
};
const initialSelectedNhName =
  isUIConverged && isNonSiteSelectionEnabledInit
    ? getSanitizedAndDecodedCookie("cl-selected-nh-name")
    : "";
let v4PayloadObject = {
  time_frame: isUIConverged
    ? timeFilterTypes[getStoredTimePeriod()]
    : timeFilterTypesCustomV4[timeFilterInit],
  entry_ts: {
    start: shortDisplayDate24HourWithSec(
      formatDate(timePeriodArray.current_period[0]).utc(),
    ),
    end: shortDisplayDate24HourWithSec(
      formatDate(timePeriodArray.current_period[1]).utc(),
    ),
  },
};
if (currentSite && parseInt(currentSite) > 0) {
  v4PayloadObject["site_id"] = parseInt(currentSite);
}
if (!("site_id" in v4PayloadObject) && initialSelectedNhName) {
  v4PayloadObject["nh_name"] = initialSelectedNhName;
}
const initialState = {
  overlays: [],
  features: {
    fabric: null,
    loader: true,
    error: null,
    available: [],
    enabled: [],
  },
  application_table_data: [],
  app_family_sla: [],
  accounts: [],
  siteAPIQuery: {},
  sdwanSiteSummary: {},
  sdwanAPIQuery: {},
  sdwanSiteSummaryLoader: true,
  sdwanSiteSummaryError: null,
  notificationInsight: {},
  notificationInsightOverlay: null,
  notificationInsightLoader: true,
  notificationInsightError: null,
  talosData: {},
  talosAPIQuery: {},
  talosSitesLoader: true,
  talosSitesError: null,
  siteAPIData: {
    sitesTableData: [],
    overviewSiteDonut: [],
    overviewSiteStacked: [],
    sitesOverviewTab: [],
    app360Sites: [],
    overviewSiteLoader: true,
    filterViewLoaderSite: true,
  },
  overviewSiteSummary: {
    site_availability: {},
    avg_availability: {},
    usage: {},
  },
  refreshTo: null,
  deviceSiteOverview: {},
  selectedSiteQuery: {},
  deviceSummaryLoader: true,
  filterViewDevice: {},
  filterViewLoaderDevice: true,
  errorFilterViewDevice: null,
  app_data_with_family_sla: undefined,
  app_data_top_usage: undefined,
  app_data_with_family_sla_data_frame: undefined,
  ssoLogout: undefined,
  applicationAggregateData: {
    isloading: false,
    resObj: undefined,
  },
  appFamilySlaData: {
    isloading: false,
    resObj: undefined,
  },
  isSALoadedandNoData: false,
  isTimeFilterHidden: false,
  sites: [],
  sitesListLoader: true,
  breadCrumbsAry: [{ label: "Analytics", url: "/overview" }],
  selectedOverlay: null,
  selectedOverlayName: null,
  selectedSite:
    currentSite && parseInt(currentSite) > 0 ? parseInt(currentSite) : -1,
  selectedNhName: initialSelectedNhName,
  selectedRemoteSite: null,
  appFlowTableTime: [],
  selectedCustomTime: null,
  timePeriodSelected: timeFilterInit,
  currentTimeStamp: null,
  isSupportRole: false,
  appGroup: "all-apps-group",
  recommendedActionsView: "viewByGain",
  recommendedActionsSearch: "",
  predictiveTabSelected: isUIConverged ? "pprTab" : "anomalyTab",
  timeFilter: {
    current_period: [
      timePeriodArray.current_period[0],
      timePeriodArray.current_period[1],
    ],
    previous_period: [
      timePeriodArray.previous_period[0],
      timePeriodArray.previous_period[1],
    ],
  },
  sideBarTimeFilter: {
    timePeriodSelected: timeFilterInit,
    currentTimeStamp: null,
    current_period: [
      timePeriodArray.current_period[0],
      timePeriodArray.current_period[1],
    ],
    previous_period: [
      timePeriodArray.previous_period[0],
      timePeriodArray.previous_period[1],
    ],
  },
  circuitsMasterTable: {
    query: {},
    queryString: "",
    loader: true,
    error: null,
    data: [],
    circuit_availability: {
      change: 0,
      current: 0,
      previous: 0,
    },
  },
  isOverlayNotProvisioned: false,
  aggregateApplicationsData: {
    isloading: false,
    resObj: undefined,
  },
  selected_apps: [],
  selected_apps_legend: null,
  notifications: [],
  selected_prev_apps: null,
  selected_apps_default: null,
  status: "",
  trend_analysis_table_filter: undefined,
  sidebar_custom_table_data: undefined,
  onAnomalyRefresh: null,
  pathanalyticsTabView: false,
  menuState: { data: null },
  globalV4Payload: v4PayloadObject,
  globalV4PayloadSidebar: JSON.parse(JSON.stringify(v4PayloadObject)),
  appFlowTimeframe: "",
  toggleView: getInitialToggleView(window.location.pathname),
  appFlowQuery: {},
  optimizationDonutChartData: {
    loader: true,
    data: {},
  },
  selectedApplications: [],
  reportsDataCount: 0,
  appQoeTableLoader: false,
};

const isSameRemoteSite = (currentRemoteSite, nextRemoteSite) => {
  if (currentRemoteSite === nextRemoteSite) {
    return true;
  }

  if (!currentRemoteSite || !nextRemoteSite) {
    return !currentRemoteSite && !nextRemoteSite;
  }

  return (
    currentRemoteSite.site_id === nextRemoteSite.site_id &&
    currentRemoteSite.site_name === nextRemoteSite.site_name
  );
};

const hasOverlayNotProvisionedError = (errorObject) => {
  const errorCode = Number(errorObject?.errorCode);
  const message = errorObject?.message;

  return (
    errorCode === 404 &&
    typeof message === "string" &&
    message.toLowerCase().includes("resources not provisioned for overlay")
  );
};

// anchor instance to dispatch actions to mfe anchor runtime properties
let anchor = { dispatch: () => undefined };
const isValidToggleViewForCurrentPath = (toggleView) =>
  getToggleConfig(window.location.pathname).allowedValues.includes(toggleView);
const syncWithMFEState = async (store) => {
  try {
    const syncWithMFEStateProp = await anchor.loadProperty(
      ANCHOR_PROPERTY_IDS.SYNC_WITH_MFE_STATE,
    );
    syncWithMFEStateProp.subscribe(() => {
      const data = syncWithMFEStateProp.get();
      if (data && Object.keys(data).length > 0) {
        const dispatchMap = [];
        const { globalFilter } = store.getState().vanalytics.app;
        if (
          data.selectedSite !== undefined &&
          (globalFilter.selectedSite !== data.selectedSite ||
            globalFilter.selectedNhName !== (data.selectedNhName || ""))
        ) {
          dispatchMap.push([actionTypes.SET_SELECTED_SITE, data.selectedSite]);
        }
        if (
          !isApplicationMFERoute(window.location.pathname) &&
          data.toggleView &&
          globalFilter.toggleView !== data.toggleView
        ) {
          dispatchMap.push([actionTypes.SET_TOGGLE, data.toggleView]);
        }
        if (
          data.selectedRemoteSite &&
          globalFilter.selectedRemoteSite !== data.selectedRemoteSite
        ) {
          dispatchMap.push([
            actionTypes.SET_SELECTED_REMOTE_SITE,
            data.selectedRemoteSite,
          ]);
        }
        if (
          data.app_data_with_family_sla &&
          globalFilter.app_data_with_family_sla !==
            data.app_data_with_family_sla
        ) {
          dispatchMap.push([
            actionTypes.SET_APP_DATA_WITH_FAMILY_SLA,
            data.app_data_with_family_sla,
          ]);
        }
        if (
          data.appFlowTableTime &&
          globalFilter.appFlowTableTime !== data.appFlowTableTime
        ) {
          dispatchMap.push([
            actionTypes.SET_APP_FLOW_TABLE_TIME_TEXT,
            data.appFlowTableTime,
          ]);
        }
        if (
          data.timePeriodSelected &&
          data.timeFilter &&
          (globalFilter.timePeriodSelected !== data.timePeriodSelected ||
            JSON.stringify(globalFilter.timeFilter) !==
              JSON.stringify(data.timeFilter))
        ) {
          if (isCustom(data.timePeriodSelected)) {
            dispatchMap.push([
              actionTypes.SET_CUSTOM_TIME,
              {
                ...data.timeFilter,
                range: data.range,
              },
            ]);
          } else {
            dispatchMap.push([
              actionTypes.SET_CTRL_TIME_FILTER,
              {
                timePeriodSelected: data.timePeriodSelected,
                time_period: data.timeFilter,
              },
            ]);
          }
        }
        dispatchMap.forEach(([id, value]) =>
          store.dispatch({ type: id, payload: value }),
        );
      }
    });
  } catch (error) {
    console.error(
      `Error loading Anchor runtime property ${ANCHOR_PROPERTY_IDS.SYNC_WITH_MFE_STATE}:`,
      error,
    );
  }
};

export const initAnchorRuntimeProperty = (store) => {
  const instance = getInstance();
  if (instance) {
    anchor = instance;
    // get the current state from redux store
    const { globalFilter } = store.getState().vanalytics.app;
    if (globalFilter) {
      const {
        selectedOverlay,
        timePeriodSelected,
        timeFilter,
        selectedCustomTime,
        selectedSite,
        selectedNhName,
        currentTimeStamp,
        sites,
        features,
        selectedRemoteSite,
        toggleView,
      } = globalFilter;

      const dispatchMap = [
        [ANCHOR_COMMAND_IDS.FABRIC, selectedOverlay],
        [ANCHOR_COMMAND_IDS.TIME_PERIOD, timePeriodSelected],
        [ANCHOR_COMMAND_IDS.TIME_RANGE, timeFilter],
        [ANCHOR_COMMAND_IDS.CUSTOM_TIME, selectedCustomTime],
        [ANCHOR_COMMAND_IDS.SITE, selectedSite],
        [ANCHOR_COMMAND_IDS.NETWORK_HIERARCHY_NAME, selectedNhName],
        [ANCHOR_COMMAND_IDS.TIMESTAMP, currentTimeStamp],
        [ANCHOR_COMMAND_IDS.SITES, sites],
        [ANCHOR_COMMAND_IDS.FEATURES, features],
        [ANCHOR_COMMAND_IDS.REMOTE_SELECTED_SITE, selectedRemoteSite],
      ];

      if (!isApplicationMFERoute(window.location.pathname)) {
        dispatchMap.push([ANCHOR_COMMAND_IDS.TOGGLE_VIEW, toggleView]);
      }

      dispatchMap.forEach(([id, value]) => instance.dispatch(id, value));
    }
    syncWithMFEState(store);
  }
};

const updateV4TimeRange = (currentPayload, timeFrame, start, end) => ({
  ...currentPayload,
  time_frame: timeFrame,
  entry_ts: {
    ...currentPayload.entry_ts,
    start,
    end,
  },
});

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.features:
      anchor.dispatch(ANCHOR_COMMAND_IDS.FEATURES, payload);
      return { ...state, features: payload };
    case actionTypes.SET_PATH_ANALYTICS_TAB:
      return {
        ...state,
        pathanalyticsTabView: payload,
      };
    case actionTypes.SET_MENU_STATE:
      return {
        ...state,
        menuState: payload,
      };
    case actionTypes.SET_ANOMALY_REFRESH:
      return {
        ...state,
        onAnomalyRefresh: payload,
      };
    case actionTypes.SET_SSO_LOGOUT:
      return {
        ...state,
        ssoLogout: payload,
      };

    case actionTypes.SET_SDWAN_SITE_SUMMARY:
      return {
        ...state,
        sdwanSiteSummary: payload.sdwanSiteSummary,
        sdwanAPIQuery: payload.sdwanAPIQuery,
        sdwanSiteSummaryLoader: false,
      };

    case actionTypes.SET_SDWAN_SITE_SUMMARY_ERROR: {
      return {
        ...state,
        sdwanSiteSummary: {},
        sdwanSiteSummaryError: payload.errorObject,
        sdwanSiteSummaryLoader: false,
      };
    }
    case actionTypes.SET_SDWAN_SITE_SUMMARY_LOADER: {
      return {
        ...state,
        sdwanSiteSummary: {},
        sdwanSiteSummaryLoader: true,
        sdwanSiteSummaryError: null,
      };
    }

    case actionTypes.SET_TALOS_SITES:
      return {
        ...state,
        talosData: payload.talosData,
        talosAPIQuery: payload.talosAPIQuery,
        talosSitesLoader: false,
      };
    case actionTypes.SET_TALOS_ERROR: {
      return {
        ...state,
        talosData: undefined,
        talosSitesError: payload.errorObject,
        talosSitesLoader: false,
      };
    }
    case actionTypes.SET_TALOS_LOADER: {
      return {
        ...state,
        talosData: undefined,
        talosSitesError: null,
        talosSitesLoader: true,
      };
    }

    case actionTypes.SET_SITES_TABLE_AVAILABILITY:
      anchor.dispatch(ANCHOR_COMMAND_IDS.SITE_API_DATA, payload);
      return {
        ...state,
        siteAPIData: {
          sitesTableData: payload.sitesTableData,
          overviewSiteDonut: payload.overviewSiteDonut,
          overviewSiteStacked: payload.overviewSiteStacked,
          sitesOverviewTab: payload.sitesOverviewTab,
          app360Sites: payload.app360Sites,
          overviewSiteLoader: false,
          filterViewLoaderSite: false,
        },
        overviewSiteSummary: {
          ...state.overviewSiteSummary,
          site_availability: {
            ...payload.overviewSiteSummary.site_availability,
          },
        },
        reportOverviewSummary: {
          site_availability: payload.overviewSiteSummary.site_availability,
        },
        siteAPIQuery: payload.siteAPIQuery,
        isOverlayNotProvisioned: false,
        errorFilterViewDevice: null,
      };

    case actionTypes.SET_OVERVIEW_SITE_LOADER:
      return {
        ...state,
        siteAPIData: {
          sitesTableData: [],
          overviewSiteDonut: [],
          overviewSiteStacked: [],
          overviewSiteSummary: [],
          sitesOverviewTab: [],
          overviewSiteLoader: true,
          filterViewLoaderSite: true,
        },
        isOverlayNotProvisioned: false,
      };

    case actionTypes.SET_OVERVIEW_DEVICE_LOADER:
      return {
        ...state,
        deviceSummaryLoader: payload,
        filterViewLoaderDevice: payload,
      };

    case actionTypes.SET_OVERVIEW_ERROR: {
      return {
        ...state,
        siteAPIData: {
          sitesTableData: [],
          overviewSiteDonut: [],
          overviewSiteStacked: [],
          overviewSiteSummary: [],
          sitesOverviewTab: [],
          overviewSiteLoader: false,
          filterViewLoaderSite: false,
          overviewSiteError: payload.errorObject,
          errorFilterViewSite: payload.errorObject, // overview sites summary error
        },
        isOverlayNotProvisioned: hasOverlayNotProvisionedError(
          payload.errorObject,
        ),
      };
    }

    case actionTypes.SET_DEVICE_OVERVIEW_ERROR: {
      return {
        ...state,
        deviceSiteOverview: {},
        deviceSummaryLoader: false,
        filterViewDevice: { devices: payload.errorObject },
        filterViewLoaderDevice: false,
        errorFilterViewDevice: payload.errorObject,
      };
    }
    case actionTypes.SET_DEVICE_SITE:
      return {
        ...state,
        overviewSiteSummary: {
          ...state.overviewSiteSummary,
          avg_availability: {
            ...payload.avg_availability,
          },
          usage: {
            ...payload.usageSummary,
          },
        },
        deviceSiteOverview: payload.deviceData,
        filterViewDevice: { devices: payload.deviceSitesummary },
        selectedSiteQuery: payload.selectedSiteQuery,
        deviceSummaryLoader: false,
        filterViewLoaderDevice: false,
        errorFilterViewDevice: null,
      };
    case actionTypes.SET_OVERLAYS:
      return {
        ...state,
        overlays: payload,
      };
    case actionTypes.SET_SELECTED_OVERLAY: {
      localStorage.setItem(currentOverlay, payload.overlayId);
      localStorage.setItem(currentOverlayName, payload.overlayName);
      setRumUser(payload.overlayId);
      updateRumSite(-1);
      anchor.dispatch(ANCHOR_COMMAND_IDS.FABRIC, payload.overlayId);
      return {
        ...state,
        selectedOverlay: payload.overlayId,
        selectedOverlayName: payload.overlayName,
        refreshTo: null,
        onAnomalyRefresh: null,
      };
    }
    case actionTypes.SET_SIDE_BAR_TIME_FILTER: {
      const updateSideBarFilter =
        payload.time_period === null
          ? {
              current_period: state.sideBarTimeFilter.current_period,
              previous_period: state.sideBarTimeFilter.previous_period,
            }
          : state.selectedSite > 0
            ? {
                ...payload.time_period,
                ...{
                  filter: {
                    site_id: state.selectedSite,
                  },
                },
              }
            : getDefaultTimeFilter(payload);
      const globalV4PayloadSidebar =
        isCustom(payload.timePeriodSelected) === false
          ? updateV4TimeRange(
              state.globalV4PayloadSidebar,
              validateTimePeriodSelectedSidebarPayload(payload),
              shortDisplayDate24HourWithSec(
                formatDate(payload.time_period.current_period[0]).utc(),
              ),
              shortDisplayDate24HourWithSec(
                formatDate(payload.time_period.current_period[1]).utc(),
              ),
            )
          : updateV4TimeRange(
              state.globalV4PayloadSidebar,
              state.globalV4Payload.time_frame,
              state.globalV4Payload.entry_ts.start,
              state.globalV4Payload.entry_ts.end,
            );
      return {
        ...state,
        globalV4PayloadSidebar,
        sideBarTimeFilter: {
          ...{ timePeriodSelected: payload.timePeriodSelected },
          ...updateSideBarFilter,
        },
      };
    }

    case actionTypes.SET_CTRL_TIME_FILTER: {
      const updatedFilter =
        state.selectedSite > 0
          ? {
              ...payload.time_period,
              ...{
                filter: {
                  site_id: state.selectedSite,
                },
              },
            }
          : getDefaultTimeFilter(payload);
      const timeFrame = payload.time_frame
        ? { time_frame: payload.time_frame }
        : {};

      let globalV4Payload = state.globalV4Payload;
      let globalV4PayloadSidebar = state.globalV4PayloadSidebar;
      if (isCustom(payload.timePeriodSelected) === false) {
        anchor.dispatch(
          ANCHOR_COMMAND_IDS.TIME_PERIOD,
          payload.timePeriodSelected,
        );
        const validatedTimeFrame = validateTimePeriodSelected(
          payload.timePeriodSelected,
        );
        const start = shortDisplayDate24HourWithSec(
          formatDate(payload.time_period.current_period[0]).utc(),
        );
        const end = shortDisplayDate24HourWithSec(
          formatDate(payload.time_period.current_period[1]).utc(),
        );
        globalV4Payload = updateV4TimeRange(
          state.globalV4Payload,
          validatedTimeFrame,
          start,
          end,
        );
        globalV4PayloadSidebar = updateV4TimeRange(
          state.globalV4PayloadSidebar,
          validatedTimeFrame,
          start,
          end,
        );
      }

      const result = {
        ...state,
        ...timeFrame,
        globalV4Payload,
        globalV4PayloadSidebar,
        selectedCustomTime: !isCustom(payload.timePeriodSelected)
          ? null
          : state.selectedCustomTime,
        timeFilter: !isCustom(payload.timePeriodSelected)
          ? { ...updatedFilter }
          : state.timeFilter,
        timePeriodSelected: payload.timePeriodSelected,
        sideBarTimeFilter: {
          current_period: payload.time_period.current_period,
          previous_period: payload.time_period.previous_period,
        },
        siteAPIQuery: {
          timePeriodSelected: payload.timePeriodSelected,
        },
        selectedSiteQuery: {
          timePeriodSelected: payload.timePeriodSelected,
        },
      };
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIME_RANGE, result.timeFilter);
      anchor.dispatch(
        ANCHOR_COMMAND_IDS.CUSTOM_TIME,
        result.selectedCustomTime,
      );
      return result;
    }
    case actionTypes.SET_REFRESH: {
      const timePeriod = isCustom(state.timePeriodSelected)
        ? {
            current_period: state.timeFilter.current_period,
            previous_period: state.timeFilter.previous_period,
          }
        : getTimePeriodELT(state.timePeriodSelected);
      const entry_ts = {
        start: getFormattedUTCDate(timePeriod.current_period[0]),
        end: getFormattedUTCDate(timePeriod.current_period[1]),
      };
      const result = {
        ...state,
        currentTimeStamp: Date.now(),
        timeFilter: { ...state.timeFilter, ...timePeriod },
        sideBarTimeFilter: { ...timePeriod },
        globalV4Payload: {
          ...state.globalV4Payload,
          entry_ts: { ...entry_ts },
        },
        globalV4PayloadSidebar: {
          ...state.globalV4Payload,
          entry_ts: { ...entry_ts },
        },
        refreshTo: Math.random(),
      };
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIME_RANGE, result.timeFilter);
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIMESTAMP, result.currentTimeStamp);
      return result;
    }
    case actionTypes.SET_SITES:
      anchor.dispatch(ANCHOR_COMMAND_IDS.SITES, payload.data);
      return {
        ...state,
        sitesListLoader: payload.isLoading,
        sites: payload.data,
      };

    case actionTypes.SET_SELECTED_REMOTE_SITE:
      if (isSameRemoteSite(state.selectedRemoteSite, payload)) {
        return state;
      }

      anchor.dispatch(ANCHOR_COMMAND_IDS.REMOTE_SELECTED_SITE, payload);
      return {
        ...state,
        selectedRemoteSite: payload,
      };

    case actionTypes.SET_APP_FLOW_TABLE_TIME_TEXT:
      return {
        ...state,
        appFlowTableTime: payload,
      };

    case actionTypes.SET_SELECTED_SITE: {
      const convergedSite = getConvergedCookie("currentSite");
      const payloadSite = parseInt(payload);
      let siteId =
        isUIConverged && convergedSite > 0 && payloadSite !== -1
          ? convergedSite
          : payloadSite;

      if (payloadSite !== convergedSite) {
        siteId = payloadSite;
      }

      if (isUIConverged) {
        if (siteId > 0) updateCookie("currentSite", siteId);
        else {
          updateCookie("currentSite", null);
        }
      }

      setLocalStorageFlag("currentSite", siteId);
      updateRumSite(siteId);

      const decodedNhName = getSanitizedAndDecodedCookie("cl-selected-nh-name");
      const isNonSiteSelection = !(payloadSite > 0);
      const nhNameForPayload = isNonSiteSelection ? decodedNhName : "";

      // Check if nh_name has changed (non-site label switch)
      const nhNameChanged = nhNameForPayload !== (state.selectedNhName || "");

      if (
        payload == undefined ||
        (state.timeFilter.filter &&
          siteId === state.timeFilter.filter.site_id &&
          !nhNameChanged)
      )
        return state;

      const updatedFilterWithSite =
        siteId > 0
          ? {
              ...state.timeFilter,
              ...{
                filter: {
                  site_id: siteId,
                },
              },
            }
          : getDefaultTimeFilter(state.timeFilter);

      const updatedGlobalV4Payload = { ...state.globalV4Payload };
      const updatedGlobalV4PayloadSidebar = { ...state.globalV4PayloadSidebar };

      if (payloadSite > 0) {
        updatedGlobalV4Payload["site_id"] = payloadSite;
        updatedGlobalV4PayloadSidebar["site_id"] = payloadSite;
        if ("nh_name" in updatedGlobalV4Payload) {
          delete updatedGlobalV4Payload.nh_name;
        }
        if ("nh_name" in updatedGlobalV4PayloadSidebar) {
          delete updatedGlobalV4PayloadSidebar.nh_name;
        }
      } else {
        if ("site_id" in updatedGlobalV4Payload) {
          delete updatedGlobalV4Payload.site_id;
        }
        if ("site_id" in updatedGlobalV4PayloadSidebar) {
          delete updatedGlobalV4PayloadSidebar.site_id;
        }
        if (nhNameForPayload) {
          updatedGlobalV4Payload["nh_name"] = nhNameForPayload;
          updatedGlobalV4PayloadSidebar["nh_name"] = nhNameForPayload;
        } else {
          if ("nh_name" in updatedGlobalV4Payload) {
            delete updatedGlobalV4Payload.nh_name;
          }
          if ("nh_name" in updatedGlobalV4PayloadSidebar) {
            delete updatedGlobalV4PayloadSidebar.nh_name;
          }
        }
      }

      const result = {
        ...state,
        selectedSite: siteId,
        selectedRemoteSite: null,
        timeFilter: updatedFilterWithSite,
        selectedNhName: nhNameForPayload,
        refreshTo: Math.random(),
        globalV4Payload: updatedGlobalV4Payload,
        globalV4PayloadSidebar: updatedGlobalV4PayloadSidebar,
      };
      if (result.selectedSite !== state.selectedSite) {
        anchor.dispatch(ANCHOR_COMMAND_IDS.SITE, result.selectedSite);
      }
      if (result.selectedNhName !== state.selectedNhName) {
        anchor.dispatch(
          ANCHOR_COMMAND_IDS.NETWORK_HIERARCHY_NAME,
          result.selectedNhName,
        );
      }
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIME_RANGE, result.timeFilter);
      return result;
    }

    case actionTypes.SET_CUSTOM_TIME: {
      const siteFilter =
        state.selectedSite > 0
          ? {
              filter: {
                site_id: state.selectedSite,
              },
            }
          : {};
      const _timePeriod = {
        current_period: payload.current_period,
        previous_period: payload.previous_period,
        ...siteFilter,
      };
      const start = shortDisplayDate24HourWithSec(
        formatDate(payload.current_period[0]).utc(),
      );
      const end = shortDisplayDate24HourWithSec(
        formatDate(payload.current_period[1]).utc(),
      );
      const result = {
        ...state,
        globalV4Payload: updateV4TimeRange(
          state.globalV4Payload,
          "custom",
          start,
          end,
        ),
        globalV4PayloadSidebar: updateV4TimeRange(
          state.globalV4PayloadSidebar,
          "custom",
          start,
          end,
        ),
        timePeriodSelected: customTimeFilterText,
        selectedCustomTime: payload,
        timeFilter: { ..._timePeriod },
        sideBarTimeFilter: { ..._timePeriod },
      };
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIME_PERIOD, customTimeFilterText);
      anchor.dispatch(ANCHOR_COMMAND_IDS.TIME_RANGE, result.timeFilter);
      anchor.dispatch(
        ANCHOR_COMMAND_IDS.CUSTOM_TIME,
        result.selectedCustomTime,
      );
      return result;
    }

    case actionTypes.SET_SIDE_BAR_CUSTOM_TIME: {
      const start = shortDisplayDate24HourWithSec(
        formatDate(payload.current_period[0]).utc(),
      );
      const end = shortDisplayDate24HourWithSec(
        formatDate(payload.current_period[1]).utc(),
      );
      return {
        ...state,
        globalV4PayloadSidebar: updateV4TimeRange(
          state.globalV4PayloadSidebar,
          "custom",
          start,
          end,
        ),
        sideBarTimeFilter: { ...payload },
      };
    }

    case actionTypes.SET_ACCOUNTS:
      return {
        ...state,
        accounts: payload,
        isSALoadedandNoData: true,
      };

    case actionTypes.SET_SELECTED_OVERLAY_ROLES: {
      localStorage.setItem(roles, JSON.stringify(payload));
      return {
        ...state,
        roles: payload,
      };
    }

    case actionTypes.SET_ALTO_PROPS:
      return {
        ...state,
        ...payload,
      };

    case actionTypes.SET_SUPPORT_ROLE:
      return {
        ...state,
        isSupportRole: payload,
      };

    case actionTypes.SET_BREADCRUMBS:
      return {
        ...state,
        breadCrumbsAry: payload,
      };
    case actionTypes.SET_APPLICATIONDATA_API_STATUS:
      return {
        ...state,
        application_table_data: payload.data,
        applicationAggregateData: {
          isloading: false,
          resObj: {
            errorCode:
              payload.errorObject && payload.errorObject.errorCode
                ? payload.errorObject.errorCode
                : 200,
            message:
              payload.errorObject && payload.errorObject.message
                ? payload.errorObject.message
                : "successful",
          },
        },
      };
    case actionTypes.SET_APP_FAMILY_SLA:
      return {
        ...state,
        app_family_sla: payload.data,
        appFamilySlaData: {
          isloading: false,
          resObj: {
            errorCode:
              payload.errorObject && payload.errorObject.errorCode
                ? payload.errorObject.errorCode
                : 200,
            message:
              payload.errorObject && payload.errorObject.message
                ? payload.errorObject.message
                : "successful",
          },
        },
      };

    case actionTypes.SET_APP_DATA_WITH_FAMILY_SLA:
      return {
        ...state,
        app_data_with_family_sla: payload,
        app_data_top_usage: payload ? payload.top_apps_usage : "",
        appFamilyWithFamilySlaData: {
          isloading: false,
          resObj: {
            errorCode: 200,
            message: "successful",
          },
        },
      };

    case actionTypes.setCircuitsLoader:
      return {
        ...state,
        circuitsMasterTable: { ...initialState.circuitsMasterTable },
      };

    case actionTypes.setCircuitsData:
      return {
        ...state,
        circuitsMasterTable: {
          ...state.circuitsMasterTable,
          ...payload,
        },
        isOverlayNotProvisioned: hasOverlayNotProvisionedError(payload.error),
      };

    case actionTypes.SET_APP_DATA_SELECTED:
      return {
        ...state,
        selected_apps: payload,
      };
    case actionTypes.SET_APP_DATA_SELECTED_LEGEND:
      return {
        ...state,
        selected_apps_legend: payload,
      };
    case actionTypes.SET_POST_LOGIN_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
      };
    case actionTypes.SET_PREV_APP_DATA_SELECTED:
      return {
        ...state,
        selected_prev_apps: payload,
      };
    case actionTypes.SET_APP_DATA_SELECTED_DEFAULT:
      return {
        ...state,
        selected_apps_default: payload,
      };
    case actionTypes.SET_TREND_ANALY_FILTER:
      return {
        ...state,
        trend_analysis_table_filter: payload,
      };
    case actionTypes.SET_SIDEBAR_TABLE_DATA:
      return {
        ...state,
        sidebar_custom_table_data: payload,
      };
    case actionTypes.TIMEFRAME_APP_FLOW:
      return {
        ...state,
        appFlowTimeframe: payload,
      };
    case actionTypes.SET_NOTIFICATION_INSIGHT_DATA:
      return {
        ...state,
        notificationInsight: payload.insightList,
        notificationInsightOverlay: payload.selectedOverlay,
        notificationInsightLoader: false,
      };

    case actionTypes.SET_NOTIFICATION_INSIGHT_ERROR: {
      return {
        ...state,
        notificationInsight: {},
        notificationInsightOverlay: null,
        notificationInsightError: payload.errorObject,
        notificationInsightLoader: false,
      };
    }
    case actionTypes.SET_NOTIFICATION_INSIGHT_LOADER: {
      return {
        ...state,
        notificationInsight: {},
        notificationInsightOverlay: null,
        notificationInsightLoader: true,
        notificationInsightError: null,
      };
    }
    case actionTypes.SET_TOGGLE:
      if (!isValidToggleViewForCurrentPath(payload)) {
        return state;
      }

      storeToggleView(window.location.pathname, payload);

      if (state.toggleView === payload) {
        return state;
      }

      if (!isApplicationMFERoute(window.location.pathname)) {
        anchor.dispatch(ANCHOR_COMMAND_IDS.TOGGLE_VIEW, payload);
      }
      return {
        ...state,
        toggleView: payload,
      };

    case actionTypes.SET_APP_FLOW_QUERY:
      return {
        ...state,
        appFlowQuery: payload,
      };

    case actionTypes.SET_OPTIMIZATION_DONUT_CHART_DATA:
      return {
        ...state,
        optimizationDonutChartData: {
          ...state.optimizationDonutChartData,
          ...payload,
        },
      };

    case actionTypes.SET_OPTIMIZATION_DONUT_CHART_LOADER:
      return {
        ...state,
        optimizationDonutChartData: {
          ...state.optimizationDonutChartData,
          loader: payload,
        },
      };

    case actionTypes.SET_SELECTED_APPLICATIONS:
      return {
        ...state,
        selectedApplications: payload,
      };

    case actionTypes.SET_APP_QOE_TABLE_LOADER:
      return {
        ...state,
        appQoeTableLoader: payload,
      };
    case actionTypes.SET_REPORTS_DATA_COUNT:
      return {
        ...state,
        reportsDataCount: payload,
      };
    default:
      return state;
  }
};

export default reducer;
